import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import FloatingAlert from "../../../components/FloatingAlert/FloatingAlert";
import bgSliders from "../../../helpers/bgSliders";
import "./SignupPage.scss";
import DzoSignupPageDisplay from "./SignupPage.styled";
import { setLoginData } from "../../../helpers/helpers";
import { Trans, withTranslation } from "react-i18next";
import { useHistory } from 'react-router-dom';
import { setAgencyData, saveTracker } from "../../../helpers/agencyTracker";
import queryString from "query-string";
import * as localLang from "../../../i18n/i18n";
import { act } from "react";


const randomBg = bgSliders.getRandomBg();
function DzoSignupPage({ t, i18n }) {
  const [activeData, setActiveData] = useState("");
  const [transactionidentify,setTransactionidentify] = useState("");
  const [transactionid,setTransactionid] = useState("");
  const [checkPhone, setCheckPhone] = useState(false);
  const [showverif, setShowverif] = useState(false);
  const [verifyCode, setVerifyCode] = useState("");
  const [errorMesg, setErrorMesg] = useState(false);
  const [verfiErrorMesg, setVerfiErrorMesg] = useState(false);
  const [errorresverify, seterrorresverify] = useState("");
  const [agree, setagree] = useState(true);
  const [showterms, setshowterms] = useState(true);
  const [errorMesgSubscribe, setErrorMesgSubscribe] = useState("");
  const [signupPlan, setSignupPlan] = useState("d");
  const [otpid, setotpid] = useState("");
  const [showLoading, setshowLoading] = useState(false);
  const [showSub, setshowSub] = useState(false);
  const [showPendding, setshowPendding] = useState(true);
   const [phonenumber , setphonenumber] = useState("");
   const [sub_id , setsub_id] = useState("");
    const [showSignUp, setShowSignUp] = useState(false);
    const [showPinFlow, setShowPinFlow] = useState(false);



  const history = useHistory();
  const [alert, setAlert] = useState(false);

  const language =
    (i18n && i18n.language) || localStorage.getItem("i18nextLng") || "ar";
  const changeLanguage = (lng) => {
    if (!i18n || !lng) return;
    i18n.changeLanguage(lng);
    localStorage.setItem("i18nextLng", lng);
    

    // Keep existing query params, just update `lang`
    const url = new URL(window.location.href);
    url.searchParams.set("lang", lng);
    window.history.pushState({}, "", url.toString());
  };


  const plans = [
    {
      plan: "d",
      name: "Daily"
    },
    {
      plan: "w",
      name: "Weekly"
    }
  ];


  useEffect(() => {
 
    const params = queryString.parse(window.location.search);
    if (params.lang) {
      localStorage.setItem("i18nextLng", params.lang);
      if(localStorage.getItem("i18nextLng") != params.lang){
        localStorage.setItem("i18nextLng", params.lang);
        window.location.reload();
      }
    
    }
    const path = window.location.pathname;
    if (path.includes("procedding2")) {
      checkoutTransaction(params);
    }else if (path.includes("signup")) {
      setShowSignUp(true);
    }
 
    getScript();
  


    const urlsearch = window.location.search;
    if (urlsearch !== "") {
     //console.log("tracker")
      setAgencyData(urlsearch);
    }
  }, []);

async function getScript() {
  const path = window.location.pathname;

  let type = '';
  if (path.includes('signup')) {
    type = 'he';
  } else if (path.includes('procedding2')) {
    type = 'pin';
  }

  const url = `https://vas1.grand-hub.com/api/PlayIt/ooredoo-alg-d-migrat/antifraud?id=signupbut&type=${type}`;

  try {
    const res = await axios.post(url);
  
    if (res.data.success === true) {
      const addScript = document.createElement('script');
      addScript.innerHTML = res.data.data.script;
      document.head.appendChild(addScript);
     localStorage.setItem('transaction', res.data.data.transaction);
     localStorage.setItem('time', res.data.data.time);

      var event = new Event('DCBProtectRun');
      document.dispatchEvent(event);
    } else {
      setErrorMesg(true);
      setErrorMesgSubscribe(res.data.data.message);
    }
  } catch (error) {
    console.error(error);
    // setErrorMesg(true);
  } finally {
    setshowLoading(false);
  }
}
async function checkoutTransaction(payload) {
 const body ={
  ...payload,
  company:localStorage.getItem("trackerCompany"),
  key:localStorage.getItem("tracker")
 }
  const url = `https://vas1.grand-hub.com/api/PlayIt/ooredoo-alg-d-migrat/check`;

  try {
    const res = await axios.post(url , body);
  
    if (res.data.success === true) {
      localStorage.setItem('phone', res.data.phone);
      console.log("phone", res.data.phone);
       history.push("/success");
    } else {
       setShowSignUp(true);
       setShowPinFlow(true);
    }
  } catch (error) {
          setShowSignUp(true);
                 setShowPinFlow(true);


  } finally {
    setshowLoading(false);
  }
}
  
 


  function gtag_report_conversion() {
    let tracker_value = localStorage.getItem('tracker');
      if(localStorage.getItem(tracker_value) != '1'){
        window.gtag('event', 'conversion', {
          'send_to': 'AW-619421651/C_ScCIHe_qcZENO_rqcC'
      });
      localStorage.setItem(tracker_value,'1')
    }
    return false;
  }


  function manipulateMsisdn(msisdn) {
    msisdn = msisdn.replace('+', '');
    if (startsWith(msisdn, '0')) {
        msisdn = msisdn.substring(1);
    } else if (startsWith(msisdn, '00')) {
        msisdn = msisdn.substring(2);
    }
    if (!startsWith(msisdn, '213')) {
        msisdn = '213' + msisdn;
    }
    return msisdn.trim();
}

function startsWith(str, prefix) {
    return str.indexOf(prefix) === 0;
}

    // save tracker
    const tracker = async (GMSISDN) => {
      var datag = {};
      if (localStorage.getItem('tracker')) {
        var op_id = 'zFGLFvkj8L';
        datag = {
          key: 'parameter',
          company: localStorage.getItem("trackerCompany"),
          value: localStorage.getItem('tracker'),
          identifierKey: 'id',
          identifierValue: op_id,
          phoneNum: GMSISDN
        };
       //console.log(datag)  
      }
      await saveTracker(datag);
  
    }
 async function getRedirectURL(){
    const transaction = localStorage.getItem('transaction');
    const time = localStorage.getItem('time');
     const body = {transaction: transaction , time: time};
   const url = `https://vas1.grand-hub.com/api/PlayIt/ooredoo-alg-d-migrat/checkout`;
    await axios.post(url ,body)
    .then(response => {
    
       const url = response.data.url;
       if(url !=="" && url != null){
         
           window.location.href=url;
       }
      
      
    })
    .catch(error=> {
      console.log(error);
      
    })
    
  }
 
  const Subscribe = async e => {
         e.preventDefault();

           const phone_number_val = activeData;

     
     if (phone_number_val) {
      console.log('phone')
      var phon_n = phone_number_val.toString();
       const url = `https://vas1.grand-hub.com/api/PlayIt/ooredoo-alg-d-migrat/subscribe`
       setshowLoading(false);
       await axios.post(url , { phone: phon_n })
         .then(res => {
           if (res.data.success === true) {
             setShowverif(true)
           }
           else {
             if (res.data.message != null) {
               setErrorMesgSubscribe(res.data.message); 
             }
              else if (res.data.blacklisted ) {  
        
          setErrorMesgSubscribe('ce numéro de téléphone est sur liste noire, veuillez en utiliser un autre')
          
          }
             else {
              setErrorMesgSubscribe(t("Something went wrong! Please make sure you have the correct number inserted or try again later.")); 
             }
            // setShowverif(true) 
 
           }
           setshowLoading(false);
 
         })
         .catch(function (error) {
           setErrorMesg(true)
           setShowverif(false)
         })
         .finally(function () {
          //console.log('complete');
         });
 
 
     }
   };
 
 
   const verify = async e => {
     e.preventDefault();
     if (verifyCode) {
       var phon_n = activeData;
       setshowLoading(false);
       const transaction = localStorage.getItem('transaction');
    const time = localStorage.getItem('time');
       axios.post(`https://vas1.grand-hub.com/api/PlayIt/ooredoo-alg-d-migrat/verify` , { phone: phon_n, otp: verifyCode  , transaction: transaction , time: time})
         .then(res => {
          //console.log(res);
          setshowLoading(true);
           if (res.data.success == true) {
           
            setTimeout(() => {
              history.push("/success", { replace: true });
            }, 2500);
                
           } else {
             if (res.data.message != null) {
              setErrorMesgSubscribe(res.data.message);
               //setVerfiErrorMesg(true);
 
             }
             else if (res.data.blacklisted ) {  
        
          setErrorMesgSubscribe('ce numéro de téléphone est sur liste noire, veuillez en utiliser un autre')
          
          }
             else {
              setErrorMesgSubscribe(t("Something went wrong! Please make sure you have the correct verification code inserted or try again later."));
               //----setVerfiErrorMesg(true);
 
 
             }
    
           }
           setshowLoading(true);
 
         })
        .catch(function (error) {
 
  if (error.response) {
    console.log('Error response:', error.response.data.message);  
    setVerfiErrorMesg(true);
    seterrorresverify(error.response.data.message);
  } 
})

         .finally(function () {
 
          //console.log('complete');
         });
     }
   };

  const plansOptions = plans.map((c, k) => {
    return (
      <option key={`plan-${k}`} value={c.plan}>
        {c.name}
      </option>
    );
  });

  const handlclick = e => {
    e.preventDefault();
//    setshowbutton(true);
    setshowterms(false);
  }
  
  

  function sendData(e) {
    e.preventDefault();
     const path = window.location.pathname;
    if (path.includes("procedding2")) {
      Subscribe(e);
    }else if (path.includes("signup")) {
     getRedirectURL();
    }
 

  }
  return (

    <>
    {showSignUp && (
  <DzoSignupPageDisplay
    className=""
    dir={language === "ar" ? "rtl" : "ltr"}
  >
      {alert && (
        <FloatingAlert type={"danger"}>
          In order to signup please turn your mobile data.
        </FloatingAlert>
      )}

      {errorMesg ? (
        <FloatingAlert type={"error"}>
          <Trans>{errorMesgSubscribe}</Trans>
        </FloatingAlert>
      ) : null}

      {verfiErrorMesg ? (
        <FloatingAlert type={"error"}>
          <Trans>{errorresverify}</Trans>
        </FloatingAlert>
      ) : null}

      <div className='operatorSignup'>
        <div className="formsLayout formsLayoutjawal">

          <div className='header header_gamezone d-flex justify-content-between align-items-center'>
            <Link to="/">
              <div className='logo logo gamezoneLogo' />
            </Link>
            <div style={{ display: "flex", justifyContent: "center" }}>
            <select
              value={language}
              onChange={(e) => changeLanguage(e.target.value)}
              style={{
                padding: "2px 2px",
                borderRadius: 10,
                border: "1px solid rgba(255,255,255,0.35)",
                background: "rgba(0,0,0,0.25)",
                color: "white",
                outline: "none",
               
              }}
              aria-label="Language"
            >
              <option value="ar">العربية</option>
              <option value="fr">Français</option>
              <option value="en">English</option>
            </select>
          </div>
          </div>

        

          {!showverif ?
            <div className="links-Section links-Sectionjawwalgamezorid">

              {/* <h3 style={{ paddingBottom: '1px' }} className="gamezoridcontent" id="gamezoridcon">
                <Trans>Your content is ready!</Trans>
              </h3> */}
              <div className="play"></div>

              {/* onSubmit={(e) => {  
        e.preventDefault();  
        (showSub)?subscribeHe(e):Subscribe(e); }}
         */}
      <form name="formsubmit" >




{showPinFlow && (
  <>
            <input
                type="text"
                className="input gamezoneInput gamezonekeyph"
                value="+213"
                disabled={true}
              />
              <input
                type="text"
                className="input gamezoneInput gamezonenumph"
                placeholder="XX XXX XX XX"
                value={activeData}
                onChange={(e) => {
                  setActiveData(e.target.value.replace(/[^0-9]/g, ""));
                  setshowSub(false);
                }}
                
                name="phone_number"
                
              />
  </>
)} 
           
         
  

              <br/><br/><br/>

               <button
                id="signupbut"
                className="btn"
                disabled={agree == true ? "" : "disabled"}
                // style={{ backgroundColor: !agree ? "" : "#8ce6e6" }} 
                //disabled={activeData ? "" : "disabled"}
                type="submit"
                onClick={(e) => {
                  sendData(e);
                }}
              >
                {t("Subscribe")}
              </button>


      </form>

      <div className="ncellTos jawwalgamezoridncellTos mondiancellTos">
      {showterms ?
                  <h4>
                    <input type="checkbox" style={{ margin: '4px 9px 0' }} onChange={(e) => { setagree(!agree) }} checked={agree} />
                    <Trans>mondia_conditions.accept_condition</Trans></h4>
                  : ""}
                
       </div>

              <div className="row text-center" >
                <div className="col-xl-4 col-lg-4 col-4 px-5">
                  <div className="games-info jawwalgames-info">
                    <span>98%</span><img src="/assets/images/subscribegamezriod/like.png" alt="img" className="iconsimg" />
                    <p><Trans>evaluation</Trans></p>
                  </div>
                </div>

                <div className="col-xl-4 col-lg-4 col-4 px-5">
                  <div className="games-info jawwalgames-info">
                    <span>1000+</span><img src="/assets/images/subscribegamezriod/Repeat.png" alt="img" className="iconsimg" />
                    <p><Trans>game</Trans></p>
                  </div>
                </div>
                <div className="col-xl-4 col-lg-4 col-4 px-5">
                  <div className="games-info jawwalgames-info">
                    <span>500k+</span><img src="/assets/images/subscribegamezriod/group.png" alt="img" className="iconsimg" />
                    <p><Trans>user</Trans></p>
                  </div>
                </div>
              </div>


              <div className="footer jawwalgamezoridFooter zainiqFooter">
                {!showverif ? "" : null}
                <div className="ncellTos jawwalgamezoridncellTos">
                  {/* <h3><Trans>terms_and_conditions</Trans></h3> */}
                  <p style={{lineHeight:"1.2",margin:"0 0 5px 0"}}><Trans>trendy-condtion_tandc1</Trans></p>
                  {/* <p><Trans>zainiq-condtion-gamezone_tandc2</Trans></p> */}
                  {/* <p style={{lineHeight:"1.2",margin:"0 0 5px 0"}}><Trans>trendy-condtion_tandc3</Trans></p> */}
                  <p style={{lineHeight:"1.2",margin:"0 0 5px 0"}}><Trans>trendy-condtion_tandc4</Trans></p>
                  {/* <p style={{lineHeight:"2px"}}><Trans>libyana-condtion_tandc5</Trans></p> */}
                  <p style={{lineHeight:"1.2",margin:"0 0 5px 0"}}><Trans>trendy-condtion_tandc6</Trans></p>
                  {/* <p> <Trans>JAWWALGameSUBSCRIBE_TAX</Trans> </p>
                  <p> <Trans>JAWWALGamSUBSCRIBEUNSUBSCRIBE</Trans> </p> */}
                </div>
              </div>
            </div>

            : null}

          {showverif ?
            <div className="verfiySection">
              <p><Trans>verifycodeJawwalGameszorid</Trans></p>
              <input
              
                type="text"
                className="input"
                value={verifyCode}
                placeholder={t("Enter_verifycode")}
                onChange={(e) => setVerifyCode(e.target.value.replace(/[^0-9]/g, ""))}
              />
              <br></br>
              <br></br> <br></br>
              <button
                className="btn"
                disabled={verifyCode ? "" : "disabled"}
                onClick={(e) => {
                  verify(e);
                }} >
                {t("Verify")}
              </button>

            </div> : null
          }

          {showLoading ?
            <div className="load">
              <div className="spinerC">
                <div className="spinner"></div>
              </div>
            </div>
            : null}




        </div>
      </div>

      

    </DzoSignupPageDisplay> 
    )}
    
    </>
    
    
   
  );
}
export default withTranslation()(DzoSignupPage)
